const SECRET = /^[A-Z2-7]{16,128}=*$/;

export default function totpSecretOf(uri: string | null | undefined): string | null {
    if (typeof uri !== 'string' || !uri.startsWith('otpauth://')) return null;
    try {
        const secret = new URL(uri).searchParams.get('secret')?.toUpperCase() ?? '';
        return SECRET.test(secret) ? secret.replace(/=+$/, '').replace(/(.{4})/g, '$1 ').trim() : null;
    } catch {
        return null;
    }
}
